export const DISTANCE_FROM_ITEM = 32;
export const VERTICAL_MARGIN = 16;
export const TOP_BAR_HEIGHT = 82;

export const calculatePreviewPosition = (previewRect: DOMRect, hoverItemRect: DOMRect) => {
	const { scrollY, innerHeight } = window;

	const previewLeftPosition = hoverItemRect.left - previewRect.width - DISTANCE_FROM_ITEM;

	const hoverItemCenter = hoverItemRect.top + hoverItemRect.height / 2;
	const previewCenter = previewRect.height / 2;

	const previewTopPosition = scrollY + (hoverItemCenter - previewCenter);

	const maxTopPosition = scrollY + innerHeight - VERTICAL_MARGIN - previewRect.height;
	if (previewTopPosition > maxTopPosition) {
		return { top: maxTopPosition, left: previewLeftPosition };
	}

	const minTopPosition = scrollY + TOP_BAR_HEIGHT + VERTICAL_MARGIN;
	if (previewTopPosition < minTopPosition) {
		return { top: minTopPosition, left: previewLeftPosition };
	}

	return { top: previewTopPosition, left: previewLeftPosition };
};
